module.exports = __webpack_public_path__ + "static/media/admin-control-panel-flat-illustration.cb6f14ba.jpg";